import { render, staticRenderFns } from "./user-spin-echart-stat.vue?vue&type=template&id=5484cf4a&scoped=true&"
import script from "./user-spin-echart-stat.vue?vue&type=script&lang=js&"
export * from "./user-spin-echart-stat.vue?vue&type=script&lang=js&"
import style0 from "./user-spin-echart-stat.vue?vue&type=style&index=0&id=5484cf4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5484cf4a",
  null
  
)

export default component.exports